import { action, observable } from "mobx";

import {
  AccScheduleTransactionStatuses,
  BillingStatuses
} from "@libs/gateways/billing/BillingGateway.dtos.ts";
import type { IRootStore } from "@shared-types/root/root-store.interface.ts";
import { Encounter } from "@stores/clinical/models/Encounter.ts";

export class ChangeConditionHelper {
  constructor(private root: IRootStore) {}

  @observable
  showChangeConditionSecondColumn: boolean = false;

  @action
  setShowChangeConditionSecondColumn = (val: boolean) => {
    this.showChangeConditionSecondColumn = val;
  };

  @observable
  showChangeConditionDialog: boolean = false;

  @action
  setShowChangeConditionDialog = (val: boolean) => {
    this.showChangeConditionDialog = val;
  };

  checkIfCanChangeCondition = async (
    encounter: Encounter
  ): Promise<boolean> => {
    await this.root.booking.getAppointmentEncounters({
      encounterId: encounter.id
    });

    const calendarEventId = encounter.calendarEventId;

    // there should always be a calendar event if the encounter has been finalised
    if (!calendarEventId) return false;

    const invoices = await this.root.billing.fetchInvoicesNew({
      calendarEventIds: [calendarEventId],
      billingStatuses: [BillingStatuses.current]
    });

    return invoices.results.every(invoice => {
      const notAllowedStatuses = [
        AccScheduleTransactionStatuses.Queued,
        AccScheduleTransactionStatuses.Pending,
        AccScheduleTransactionStatuses.AwaitingAuthorisation,
        AccScheduleTransactionStatuses.Authorised,
        AccScheduleTransactionStatuses.Paid,
        AccScheduleTransactionStatuses.PartiallyPaid,
        AccScheduleTransactionStatuses.NotReady,
        AccScheduleTransactionStatuses.Ready,
        AccScheduleTransactionStatuses.Error
      ];

      return (
        invoice.accSchedule?.transactionStatus &&
        !notAllowedStatuses.includes(invoice.accSchedule.transactionStatus)
      );
    });
  };
}
